import BaseCrud from './baseCrud';

const crud = new BaseCrud('question');

export const state = () => ({
    ...crud.state,
    SHORT: 'short',
    LONG: 'long',
    WYSIWYG: 'wysiwyg',
    NUMBER: 'number',
    EMAIL: 'email',
    CHECKBOX: 'checkbox',
    DROPDOWN: 'dropdown',
    MULTI_SELECT: 'multiSelect',
    FILE: 'file'
});

export const getters = {
    ...crud.getters,
    SHORT: state => state.SHORT,
    LONG: state => state.LONG,
    WYSIWYG: state => state.WYSIWYG,
    NUMBER: state => state.NUMBER,
    EMAIL: state => state.EMAIL,
    CHECKBOX: state => state.CHECKBOX,
    DROPDOWN: state => state.DROPDOWN,
    MULTI_SELECT: state => state.MULTI_SELECT,
    FILE: state => state.FILE,
    types: state => [
        {
            text: 'Short text',
            value: state.SHORT,
            btnVariant: 'success'
        },
        {
            text: 'Long text',
            value: state.LONG,
            btnVariant: 'primary'
        },
        {
            text: 'WYSIWYG',
            value: state.WYSIWYG,
            btnVariant: 'danger'
        },
        {
            text: 'Number',
            value: state.NUMBER,
            btnVariant: 'danger'
        },
        {
            text: 'E-mail',
            value: state.EMAIL,
            btnVariant: 'warning'
        },
        {
            text: 'Checkbox',
            value: state.CHECKBOX,
            btnVariant: 'info'
        },
        {
            text: 'Dropdown',
            value: state.DROPDOWN,
            btnVariant: 'secondary'
        },
        {
            text: 'Multiple select',
            value: state.MULTI_SELECT,
            btnVariant: 'light'
        },
        {
            text: 'File',
            value: state.FILE,
            btnVariant: 'dark'
        }
    ]
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions
};
